// Import Package
import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';

// Import Material UI
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

// Import Icons
import errorPopUpIcon from "../../../assets/icons/configurationIcons/error-popUp.svg";

// Import CSS
import "./ConfirmPrompt.css"

function ConfirmPrompt({ titleMessage, message, submitFunc, setOpenConfirm, okButtonLabel, cancelButtonLabel, okDisabled, cancelDisabled, setOkDisabled, setCancelDisabled }) {

    const { t } = useTranslation();

    const handleOKClick = () => {
        submitFunc();
    };

    const handleClose = () => {
        setOpenConfirm(false);
        setOkDisabled(false);
        setCancelDisabled(false);
    };

    return (
        <Dialog PaperProps={{
            style: {
                width: "470px",
                maxHeight: "240px",
                borderRadius: "5px",
                boxShadow: "0px 0px 8px -3px #00000040",
                background: "#FFFFFF",
            },
        }}
                open={true} onClose={handleClose} >
            <DialogTitle className="error-popUp-title-container">
                <div className="error-popUp-icon-container">
                    <img src={errorPopUpIcon} />
                </div>
                <h2 className="error-popUp-title">
                    {titleMessage}
                </h2>
            </DialogTitle>
            <DialogContent className='error-popUp-content-container overflow-none'>
                {message && <DialogContentText className="error-popUp-message overflow-auto" color="textPrimary">
                    {message}
                </DialogContentText>}
                <div className="error-popUp-button-container">
                    <Button
                        onClick={handleOKClick}
                        disabled={okDisabled}
                        variant="outlined"
                        className='error-popUp-delete-button'>
                        {okButtonLabel ? okButtonLabel : t('CONTENT.MODAL.DELETE')}
                    </Button>
                    <Button
                        className='error-popUp-cancel-button'
                        disabled={cancelDisabled}
                        onClick={handleClose}
                        variant="outlined">
                        {cancelButtonLabel ? cancelButtonLabel : t('CONTENT.MODAL.CANCEL')}
                    </Button>
                </div>
            </DialogContent>
        </Dialog >
    );
}

export default ConfirmPrompt